import * as React from "react";
import Loader from "../../components/atoms/Loader";
import StudentFilter from "../../components/features/NewStudentFilter";
import { SectionTimelineTab } from "../../components/features/SectionTimelineTab";
import { MergedTimelineList } from "../../components/features/Timeline/MergedTimelineList";
import { TimelineResourceFilter } from "../../components/features/TimelineResourceFilter/TimelineResourceFilter";
import { ResourceFilterEmptyMessages } from "../../domains/TimelineResourceFilter";
import {
  OutletContextProps,
  WithRouterProps,
} from "../../helpers/RouterHelper";
import {
  AuthenticatedPageProps,
  AuthenticateRouterProps,
} from "../../hocs/enhanceAuthenticatedPage";
import enhanceSectionsPage from "../../hocs/enhanceSectionsPage";
import { useTimelineResourceFilter } from "../../hooks/useTimelineResourceFilter";
import SectionInterface from "../../interfaces/SectionInterface";
import { TimelineType } from "../../interfaces/TimelineInterface";
import styles from "./index.scss";
import { useMergedRealtimeTimeline } from "./useMergedRealtimeTimeline";

interface Props
  extends WithRouterProps<AuthenticateRouterProps>,
    Pick<AuthenticatedPageProps, "studentFilterContext" | "currentOperator">,
    OutletContextProps {
  section: SectionInterface;
}

// リアルタイムタブ。AI 質問統合表示の凍結（005-freeze-ai-question-timeline）に伴い、
// 学習記録タイムラインのみを表示する。フィルタ UI（TimelineResourceFilter）は
// 骨格を維持したまま画面上は非表示（visible={false}）とする。
const SectionsTimelinePage = (props: Props) => {
  React.useLayoutEffect(() => {
    props.setActiveMenu("timeline");
  }, []);

  const { filter, setFilter } = useTimelineResourceFilter();

  const {
    displayed,
    isLoading,
    isFetchingNextPage,
    updateStudyRecordQueryCache,
    drillProgressMap,
  } = useMergedRealtimeTimeline({
    sectionId: props.params.sectionId,
    resourceFilter: filter,
    enabled: !!props.section,
  });

  if (!props.section || !props.currentOperator) {
    return null;
  }
  const currentOperator = props.currentOperator;

  return (
    <>
      <SectionTimelineTab
        sectionId={props.section.id}
        timelineType={TimelineType.TIMELINE_REALTIME}
        search={props.location.search}
      />
      <StudentFilter sectionId={props.section.id} />
      {/* リソースフィルタは骨格として維持しつつ画面上は非表示。
          凍結解除時（AI 質問再開時）に visible の条件を戻せば復活する */}
      <TimelineResourceFilter
        value={filter}
        onChange={setFilter}
        visible={false}
      />
      {isLoading ? (
        <Loader loading={isLoading} />
      ) : (
        <div className={styles.root}>
          <div>
            {displayed.length === 0 ? (
              <p className="mt-4 text-center">
                {ResourceFilterEmptyMessages[filter]}
              </p>
            ) : (
              <MergedTimelineList
                displayed={displayed}
                currentOperator={currentOperator}
                updateStudyRecordQueryCache={updateStudyRecordQueryCache}
                drillProgressMap={drillProgressMap}
                itemClassName={styles.timelineItem}
              />
            )}
          </div>
          <Loader loading={isFetchingNextPage} />
        </div>
      )}
    </>
  );
};

const pageInfo = {
  title: "タイムライン",
};

export default enhanceSectionsPage(SectionsTimelinePage, pageInfo);
